
/**
 * @class ACHTemplateSearch
 * @classdesc Class definition for controlling the properties that are set in a search feature.
 * 
 * @property {STRING} _companyID - The company id to filter by
 * @property {STRING} _transactionType - The transactionType to filter by
 * @property {STRING} _participantName - The participantName to filter by
 * @property {STRING} _templateName - The templateName to filter by
 * @property {STRING} _offsetAccountID - The offsetAccountID to filter by
 */
export default class ACHTemplateSearch {
    _companyID;
    _transactionType;
    _participantName;
    _templateName;
    _offsetAccountID;

    constructor(record) {
        this.companyID = record.companyID;
        this.transactionType = record.transactionType;
        this.participantName = record.participantName;
        this.templateName = record.templateName;
        this.offsetAccountID = record.offsetAccountID;
    }

    /**
     * @name companyID
     * @instance
     * @property set {STRING} - sets the company id
     * @memberof ACHTemplateSearch
     */
    set companyID(value) { this._companyID = value; }

    /**
     * @name transactionType
     * @instance
     * @property set {STRING} - sets the transactionType
     * @memberof ACHTemplateSearch
     */
    set transactionType(value) { this._transactionType = value; }

    /**
     * @name participantName
     * @instance
     * @property set {STRING} - sets the participantName
     * @memberof ACHTemplateSearch
     */
    set participantName(value) { this._participantName = value; }

    /**
     * @name templateName
     * @instance
     * @property set {STRING} - sets the templateName
     * @memberof ACHTemplateSearch
     */
    set templateName(value) { this._templateName = value; }

    /**
     * @name offsetAccountID
     * @instance
     * @property set {STRING} - sets the offsetAccountID
     * @memberof ACHTemplateSearch
     */
    set offsetAccountID(value) { this._offsetAccountID = value; }

    
    /**
     * @name companyID
     * @instance
     * @property get {Map} - returns the companyID
     * @memberof ACHTemplateSearch
     */
    get companyID() { return this._companyID; }

    /**
     * @name transactionType
     * @instance
     * @property get {Map} - returns the transactionType
     * @memberof ACHTemplateSearch
     */
    get transactionType() { return this._transactionType; }

    /**
     * @name participantName
     * @instance
     * @property get {Map} - returns the participantName
     * @memberof ACHTemplateSearch
     */
    get participantName() { return this._participantName; }

    /**
     * @name templateName
     * @instance
     * @property get {Map} - returns the templateName
     * @memberof ACHTemplateSearch
     */
    get templateName() { return this._templateName; }

    /**
     * @name offsetAccountID
     * @instance
     * @property get {Map} - returns the offsetAccountID
     * @memberof ACHTemplateSearch
     */
    get offsetAccountID() { return this._offsetAccountID; }

    /**
     * @name filters
     * @instance
     * @property get {OBJECT} - returns the set filter properties
     * @memberof ACHTemplateSearch
     */
    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*get filters() {
        return Object.getOwnPropertyNames(this).reduce((result, name) => {
            const key = name.slice(1);
            const value = this[key];

            if(value !== undefined && value !== "" && (key !== "ranges" && key !== "types")){
                result[key] = value;
            }

            return result;
        }, {});
    }*/
    
    /**
     * @name record
     * @instance
     * @property get {OBJECT} - returns the set values
     * @memberof ACHTemplateSearch
     */
    get record() {
        return {
            companyID: this.companyID,
            transactionType: this.transactionType,
            participantName: this.participantName,
            templateName: this.templateName,
            offsetAccountID: this.offsetAccountID
        };
    }

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*checkValue(transaction, key) {
        switch(key) {
            case "date":
                return transaction.date.isAfter(BCMSDate.init().offset(this.date));
    
            case "description":
                return transaction.description.toLowerCase().indexOf(this.description.toLowerCase()) > -1;
    
            case "type":
                return this.type === "all" ? true : transaction.filterType === this.type;
    
            case "amount":
                const amount = parseFloat(transaction.amount.amount);
                return parseFloat(this.amount.amount) === (amount < 0 ? -amount : amount);
    
            case "check":
                const desc = transaction.description;
                return desc.toLowerCase().indexOf("check") > -1 && desc.indexOf(this.check) > -1;
    
            default:
                return true;
        }
    }*/

    // TO DO: This code is from class "TransactionSearch" and similar support may be needed
    // once we have data to filter.
    /*filter() {
        return Transaction.initByAccount(this.accountID)
            .filter(transaction => {
                return Object.keys(this.filters).reduce((result, key) => {
                    if(!this.checkValue(transaction, key)) {
                        result = false;
                    }

                    return result;
                }, true);
            }, []);
    }*/

    reset() {
        const vals = { 
            companyID: this.companyID,
            transactionType: this.transactionType,
            participantName: this.participantName,
            templateName: this.templateName,
            offsetAccountID: this.offsetAccountID
        };
        return ACHTemplateSearch.init(vals);
    }
    
    static init(record) {
        const vals = { 
            companyID: undefined,
            transactionType: undefined,
            participantName: undefined,
            templateName: undefined,
            offsetAccountID: undefined,
            ...record ?? {} 
        }
        return new ACHTemplateSearch(vals);
    }
}